import { ConfigProvider } from 'antd';
import { antdTheme } from './theme';
import * as React from 'react';

export const AntdWrapper: React.FC<{}> = ({ children }) => {
  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
};
